import { collection, addDoc, query, where, orderBy, getDocs } from 'firebase/firestore'
import { db } from '@/firebase'

export async function logDeviceEdit(deviceId, changes, userEmail) {
  await addDoc(collection(db, 'editHistory'), {
    deviceId,
    changes,
    editedBy: userEmail,
    editedAt: new Date()
  })
}

export async function getDeviceHistory(deviceId) {
  const q = query(
    collection(db, 'editHistory'),
    where('deviceId', '==', deviceId),
    orderBy('editedAt', 'desc')
  )
  const snapshot = await getDocs(q)
  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
}
